import { LEAD_STATUSES, type LeadStatusesValues } from "./lead-statuses.ts"

/**
 * Which lifecycle stages own the proposal and contract actions, per the "Lead
 * Status Definitions" spec.
 *
 * Estimate owns proposal creation from a proposal template or upload. Contract
 * keeps proposals visible and actionable, but only creates contracts: from a
 * contract template, an existing proposal, or upload. Won keeps upload
 * available for a signed contract.
 */
const PROPOSAL_STAGES: LeadStatusesValues[] = [
  LEAD_STATUSES.ESTIMATE,
  LEAD_STATUSES.CONTRACT
]

const PROPOSAL_CREATE_STAGES: LeadStatusesValues[] = [LEAD_STATUSES.ESTIMATE]

const CONTRACT_CREATE_STAGES: LeadStatusesValues[] = [LEAD_STATUSES.CONTRACT]

const CONTRACT_UPLOAD_STAGES: LeadStatusesValues[] = [
  ...CONTRACT_CREATE_STAGES,
  LEAD_STATUSES.WON
]

export {
  PROPOSAL_STAGES,
  PROPOSAL_CREATE_STAGES,
  CONTRACT_CREATE_STAGES,
  CONTRACT_UPLOAD_STAGES
}
